import { useEffect, useState } from 'react';
import KaModal from '../../common/KaModal';
import { KaSelectOption, KaSelect, isMultiValue } from '../../common/KaSelect';
import { FilterSettings } from './StagedPurchaseOrders';

export interface StagedPurchaseOrderFilterModalProps {
  stagedPurchaseOrderStepOptions: KaSelectOption[];
  bayOptions: KaSelectOption[];
  filters: FilterSettings;
  updateFilters: (settings: Partial<FilterSettings>) => void;
  toggle: () => void,
}

const StagedPurchaseOrderFilterModal = ({
  stagedPurchaseOrderStepOptions,
  bayOptions,
  filters,
  updateFilters,
  toggle,
}: StagedPurchaseOrderFilterModalProps) => {
  const [selectedStagedPurchaseOrderStep, setSelectedStagedPurchaseOrderStep] = useState<string>(filters.stagedPurchaseOrderStep);
  const [selectedBay, setSelectedBay] = useState<string>(filters.bay);

  useEffect(() => {
    setSelectedStagedPurchaseOrderStep(filters.stagedPurchaseOrderStep);
    setSelectedBay(filters.bay);
  }, [filters]);

  const handleFilter = () => {
    updateFilters({
      stagedPurchaseOrderStep: selectedStagedPurchaseOrderStep,
      bay: selectedBay,
    });
    toggle();
  };

  return (
    <KaModal
      isOpen={true}
      toggle={toggle}
      title={"Filter Staged Purchase Orders"}
      body={
        <div>
          <div className="row">
            <h5>Status:</h5>
            <KaSelect
              onChange={(valueObject) => {
                if (!isMultiValue(valueObject)) {
                  setSelectedStagedPurchaseOrderStep(valueObject?.value!);
                }
              }}
              placeholder="Select status"
              isClearable={true}
              options={stagedPurchaseOrderStepOptions}
              value={stagedPurchaseOrderStepOptions.find((option) => option.value === selectedStagedPurchaseOrderStep)} />
          </div>

          <div className="row mt-3">
            <h5>Bay:</h5>
            <KaSelect
              onChange={(valueObject) => {
                if (!isMultiValue(valueObject)) {
                  setSelectedBay(valueObject?.value!);
                }
              }}
              placeholder="Select bay"
              isClearable={true}
              options={bayOptions}
              value={bayOptions.find((option) => option.value === selectedBay)} />
          </div>
        </div>
      }
      footer={
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleFilter}>
          Filter
        </button>
      }
    />
  );
};

export default StagedPurchaseOrderFilterModal;